
<template>
    <div class="las_fil pb-3">
        <div class="files_block">
            
            <div class="head_list" v-if="head_items.length > 0">
                <div class="head_item" v-for="head in head_items">
                    <div  class="row doc_title mt-4">
                        <div class="col-sm-3">
                            <label for="is_random_<?= $head->id ?>" class="fs-xl">
                                {{head.field_name }}
                            </label>
                        </div>
                        <div  class="col-sm-9">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button class="btn btn-primary waves-effect waves-themed" type="button" v-on:click="edit_head(head)">
                                        <i class="fal fa-edit"></i>
                                    </button>
                                </div>
                                <input :value="head.field_val" type="text" disabled="disabled" class="fs-xl form-control form-control-sm">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="parts_inside mt-5">
                <b-table :tbody-tr-class="rowClass" head-variant="dark" :items="parts_items" :fields="fields"></b-table>
            </div>
        </div>
        
        <parts_edit_head :doc_id="mem.id"></parts_edit_head>
        <parts_edit_items :doc_id="mem.id"></parts_edit_items>
        
    </div>
</template>

<script>


import Parts_edit_head from "./editor/parts_edit_head.vue";
import Parts_edit_items from "./editor/parts_edit_items.vue";

export default {
    name: "mem_inside_parts_reserv",
    components: {Parts_edit_items, Parts_edit_head},
    props: {
        
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
        
    },
    data() {
        return  {
            
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'field_name',
                    label: 'Назва',
                    sortable: true
                },
                {
                    key: 'original_field.numberOriginal',
                    label: 'Каталожний номер',
                    sortable: true
                },
                
                {
                    key: 'field_json.qty',
                    label: 'К-ть',
                    sortable: true
                },
                
                {
                    key: 'field_json.measure',
                    label: 'Од. виміру',
                    sortable: true
                },
                
            ],
        }
    },
    
    methods: {
        rowClass(item) {
            if(item.hasOwnProperty('is_manual')) {
                if(item.is_manual) {
                    return  'table-info';
                }
            }
            
            return '';
        },
        
        edit_head (field) {
            EventBus.$emit('edit_partsreserv_head',field.field_type)
        }
    },
    
    computed : {
        head_items() {
            if(this.addon_data.hasOwnProperty('head')) {
                return this.addon_data.head;
            }
            
            return [];
        },
        
        parts_items() {
            if(this.addon_data.hasOwnProperty('parts')) {
                return this.addon_data.parts;
            }
            
            return [];
        },
    },
}
</script>



<style scoped>

</style>